import { render, staticRenderFns } from "./CustomPageBloc.vue?vue&type=template&id=24320c30&"
import script from "./CustomPageBloc.vue?vue&type=script&lang=js&"
export * from "./CustomPageBloc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports